import wrapRootElement from "./src/reduxWrapper"

import "./src/styles/constants.scss"
import "./src/styles/global.scss"

function onPreRouteUpdate({ location, prevLocation }) {}

function onRouteUpdate({ location, prevLocation }) {}

function onClientEntry() {
  // console.log("We've started!", store.getState().App.imBusy)
  // if ('serviceWorker' in navigator) {
  // 		navigator.serviceWorker
  // 			.register('/sw.js')
  // 	}
}

// const registerServiceWorker = () => true

export {
  wrapRootElement,
  onRouteUpdate,
  onPreRouteUpdate,
  onClientEntry,

  // registerServiceWorker
  // registerServiceWorker
}
